<template>
  <auth-layout>
    <div>
      <h3 class="fw-bold text-uppercase mb-2">Elige una contraseña nueva</h3>
      <p class="mb-4">
        Ingresa tu nueva contraseña y confírmala para restablecer tu cuenta.
      </p>
    </div>

    <div
      class="alert alert-danger"
      role="alert"
      v-if="hasError"
    >
      {{ msg }}.
    </div>

    <form @submit.prevent="ConfirmPassword">
      <!-- Password Input -->
      <password-input
        id="current-password"
        name="current-password"
        autocomplete="current-password"
        v-model="form.password"
        placeholder="Contraseña nueva"
        :class="{ 'is-invalid': hasError }"                
      />

      <!-- Password Confirmation Input -->
      <password-input
        id="confirm-password"
        name="confirm-password"
        placeholder="Confirmar Contraseña"
        autocomplete="confirm-password"
        v-model="form.confirm_password"
        :class="{ 'is-invalid': hasError }"                
      />

      <!-- Hidden username input -->
      <input
        type="text"
        name="username"
        autocomplete="username"
        :value="form.employee_code"
        hidden
      />

      <button
        type="submit"
        class="btn btn-portal btn-lg w-100 text-uppercase mt-3"
      >
        Continuar
      </button>

      <div class="mt-3 text-center">
        ¿Ya tienes una cuenta?
        <router-link :to="{ name: 'SignIn' }" class="buzonColor">
          Inicia sesión aquí
        </router-link>
      </div>
    </form>
  </auth-layout>
</template>

<script>
import axios from "axios";
import AuthLayout from "@/template/AuthLayout.vue";
import PasswordInput from './components/PasswordInput.vue';
export default {
  name: "newPassword",
  components: {
    AuthLayout,
    PasswordInput,
  },
  data() {
    return {
      hasError: false,
      msg: null,
      form: {
        id: this.$route.params.id,
        password: "",
        confirm_password: "",
      },
    };
  },
  methods: {
    ConfirmPassword() {
      if (this.form.password == this.form.confirm_password) {
        axios
          .post("confirmPassword", {
            data: this.form,
          })
          .then((response) => {
            alert(response.data);
            this.$router.replace({
              name: "SignIn",
            });
          })
          .catch(() => {
            this.msg = "No Usuario no valido.";
            this.hasError = true;
            setTimeout(() => {
              this.hasError = false;
            }, 5000);
            this.form.password = null;
          });
      } else {
        this.msg = "Las contraseñas no coinciden. Inténtelo de nuevo.";
        this.hasError = true;
        setTimeout(() => {
          this.hasError = false;
        }, 5000);
        this.form.password = null;
      }
    },
  },
};
</script>

<style scoped></style>
